import { render } from "./OpenConfirmation.vue?vue&type=template&id=7afd9cce&scoped=true&ts=true"
import script from "./OpenConfirmation.vue?vue&type=script&lang=ts"
export * from "./OpenConfirmation.vue?vue&type=script&lang=ts"

import "./OpenConfirmation.vue?vue&type=style&index=0&id=7afd9cce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afd9cce"]])

export default __exports__